import { Select } from '@gravity-ui/uikit';

import styles from './styles.module.scss';

interface ResultScoreSelectProps {
	value?: string;
	onChange?: (value: string) => void;
	placeholder?: string;
	size?: 'xl' | 'l' | 'm' | 's';
	disabled?: boolean;
	className?: string;
}

const SCORE_OPTIONS = [
	{ value: '+2', content: '+2 значительно выше ожидаемого' },
	{ value: '+1', content: '+1 выше ожидаемого' },
	{ value: '0', content: '0 ожидаемый' },
	{ value: '-1', content: '-1 ниже ожидаемого' },
	{ value: '-2', content: '-2 ситуация ухудшилась' },
];

export const ResultScoreSelect = ({
	value,
	onChange,
	placeholder = 'Выберите оценку',
	size = 'xl',
	disabled = false,
	className,
}: ResultScoreSelectProps) => {
	return (
		<Select
			value={value ? [value] : []}
			onUpdate={(selectedValues) => {
				const selectedValue = selectedValues[0] || '';
				onChange?.(selectedValue);
			}}
			options={SCORE_OPTIONS}
			placeholder={placeholder}
			size={size}
			disabled={disabled}
			className={`${styles.scoreSelect} ${className || ''}`}
			renderSelectedOption={(option) => {
				return <span>{option.value}</span>;
			}}
		/>
	);
};
